import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
@Injectable()
export class UsersService {

  constructor(private http:HttpClient) { }


  //get all users 

  getUsers(){
    return this.http.get('http://www.api.playit.mobi/api/v1/users/getall').map(result=>result);
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/users.service.ts